// Explore-stats page: Prior elected service in government — current Parl.
// Recreates the Handbook page — current parliamentarians who previously
// held elected office at state/territory or local level, by party.
// Best-effort: recordsofservice ROSTypeID 12 (State/Territory) & 15 (Local).

import React, { useState, useEffect } from 'react';
import { Paper, Typography, Alert } from '@mui/material';
import { getExploreStat } from '../../services/api';
import ExploreStatsPage from './ExploreStatsPage';
import { StatStackedBar } from './charts';

export default function PriorElectedService() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await getExploreStat('prior-elected-service');
        if (active) setData(res);
      } catch (e) {
        if (active) setError(e.message || 'Failed to load statistics');
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const c = data?.charts || {};

  return (
    <ExploreStatsPage
      title="Prior elected service in government — current Parliament"
      description={`Current parliamentarians who previously held elected office in a state/territory legislature or local government${
        c.total_with_service ? ` (${c.total_with_service})` : ''
      }, by party.`}
      loading={loading}
      error={error}
      columns={data?.columns || []}
      rows={data?.table_rows || []}
      links={data?._links || []}
      csvName="prior-elected-service"
    >
      {data && (
        <>
          <Alert severity="info" sx={{ mb: 2 }}>
            Best-effort: derived from records-of-service categories
            (State/Territory Government Service and Local Government Service);
            any such record is counted as prior service of that kind.
          </Alert>
          <Paper elevation={1} sx={{ p: 2, mb: 3, borderRadius: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Prior elected service in government — current Parliament
            </Typography>
            <StatStackedBar data={c.by_party || []} xKey="party"
                            keys={c.series || []} layout="vertical"
                            height={380} />
          </Paper>
        </>
      )}
    </ExploreStatsPage>
  );
}
